<template>
    <div id="main" ref="modalParametrizacao" :style="{ 'height': `${heightModal}px` }">
        <loader v-if="isLoading"/>
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
          <div class="title-breadcrumb">
            <h1 class="title">{{ parametrizacao['label-tabela-usuario'] }}</h1>
          </div>
          <div class="header-buttons">
            <button class="delete-btn" type="button" tag="button" @click="fechar()">
              {{ $t('fechar') }}
            </button>
            <button class="save-btn" type="button" @click="save" :disabled="isLoading">
              {{ $t('salvar') }}
              <button-loader :isSaving="isLoading" />
            </button>
          </div>
        </div> 
        <section>
            <div class="conteudo-parametrizacao">
                <div class="conteudo-parametrizacao-descricao">
                    <span>{{ parametrizacao.descricao }}</span>
                </div>
                <div class="conteudo-parametrizacao-valor">
                    <span>{{ $t('valor') }}:</span>
                    <v-select
                        v-if="options.length != 0"
                        ref="valorSelect"
                        class="is-100"
                        :options="options"
                        :clearable="false"
                        v-model="selected"
                    />
                    <input v-model="inputText" :type="typeInput" v-else>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ParametrizacaoService from "@/services/ParametrizacaoService";
import Message from "@/models/Message";

export default {
    data() {
        return {
            isLoading: false,
            service: new ParametrizacaoService(this.$http, this.$router),
            selected: '',
            options: [],
            msgs: [],
            inputText: this.parametrizacao.valor,
            typeInput: "text",
            heightModal: null,
        }
    },
    props: {
        parametrizacao: {}
    },
    created() {
        this.renderInput();
    },
    methods: {
        fechar(){
            this.$emit('fecharModal', 'edit');
        },
        renderInput() {
            if (this.parametrizacao.tipo) {
                let json = JSON.parse(this.parametrizacao.tipo);
                if (json.type === "select") {
                    this.options = json.options.map(e => ({ "id": e.value, "label": e.name }));
                    this.selected = this.options.find(e => e.label === this.parametrizacao.valor);
                } else {
                    this.typeInput = json.type;
                }
            }
        },
        save() {
            this.isLoading = true;

            let parametrizacaoTemp = Object.assign({}, this.parametrizacao);
            if (this.options != 0) {
                parametrizacaoTemp.valor = this.selected.id;
                parametrizacaoTemp.label = parametrizacaoTemp['label-tabela-usuario'];
            } else {
                parametrizacaoTemp.valor = this.inputText;
                parametrizacaoTemp.label = parametrizacaoTemp['label-tabela-usuario'];
            }

            this.service.save(parametrizacaoTemp)
            .then(value => {
                if (value.message == null) {
                    this.$emit('refresh');
                } else {
                    if (this.$t(value.message)) {
                        this.msgs.push(new Message('alert', value.message, true));
                    } else {
                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    }
                }
            })
            .catch((e) => {
                this.msgs.push(new Message('error', 'msg-erro-load', true));
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        addHeight() {
            this.heightModal = this.$refs.modalParametrizacao.clientHeight + 100
        },
        removeHeight() {
            this.heightModal -= 100;
        }
    }
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px !important;
    background-color: $sovis-white;

    span {
        font-size: 13px;
    }

    .conteudo-parametrizacao {
        display: flex;
        align-items: center;
        padding: 20px 0px;
        flex-direction: column;

        .conteudo-parametrizacao-descricao {
            width: 70%;
        }
    
        .conteudo-parametrizacao-valor {
            display: flex;
            align-items: center;
            flex-direction: row;
            width: 80%;
            margin-top: 15px;
            //margin-bottom: 100px;

            span {
                margin-right: 10px;
            }

            div {
                width: 100%;
                margin-top: 5px;
            }
        }
    }
}
</style>